import { Component, inject, OnInit, signal } from '@angular/core';
import { ImageCarousel } from '../../../components/admin-dashboard-component/product-details/utils/image-carousel/image-carousel';
import { ActivatedRoute } from '@angular/router';
import { ProductDetailsComponent } from '../../../components/user-dashboard-component/products/product-details-component/product-details-component';

@Component({
  selector: 'app-user-product-details',
  imports: [ProductDetailsComponent],
  templateUrl: './user-product-details.html',
  styleUrl: './user-product-details.scss',
})
export class UserProductDetails implements OnInit {
  private route = inject(ActivatedRoute);
  productId = signal('');

  ngOnInit(): void {
    const productId = this.route.snapshot.params['id'];
    this.productId.set(productId);
  }
}
